import styled from 'styled-components';

export const StyledText = styled.span`
  font-weight: ${(props) => props.fontWeight};
  font-style: ${(props) => props.fontStyle};
  color: ${(props) => props.color};
`;
